
































































import Vue from 'vue'
import { View } from '@/types/view'

export default Vue.extend({
  name: 'ViewProperties',
  props: {
    value: Object,
  },
  data() {
    return {
      model: { attributes: {} } as View,
      temporarySelect: null,
      fields: ['name', 'value'],
    }
  },
  watch: {
    value: {
      deep: true,
      // eslint-disable-next-line
      handler: function(val: any) {
        if (JSON.stringify(val) != JSON.stringify(this.model)) {
          this.model = this.value
        }
      },
    },
    model: {
      deep: true,
      handler: function(val) {
        if (JSON.stringify(val) != JSON.stringify(this.value)) {
          this.$emit('input', val)
        }
      },
    },
  },
  created() {
    JSON.parse(JSON.stringify(this.value))
  },
})
